module.exports = __webpack_public_path__ + "img/des_pintu_2.916130d2.jpg";